"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WHITE = exports.TRELLIS_SAD = exports.TRELLIS_NEUTRAL = exports.TRELLIS_HAPPY = exports.THUNDERDOME_MEDIUM = exports.THUNDERDOME_LIGHT = exports.THUNDERDOME_DARK = exports.THUNDERDOME = exports.SLINKY = exports.PANTERA = exports.OZ_MEDIUM = exports.OZ_LIGHT = exports.OZ_DARK = exports.OZ = exports.OLAF = exports.OBSIDIAN = exports.NORMAN_MEDIUM = exports.NORMAN_LIGHT = exports.NORMAN_DARK = exports.NORMAN = exports.NEUTRAL_900 = exports.NEUTRAL_800 = exports.NEUTRAL_700 = exports.NEUTRAL_600 = exports.NEUTRAL_500 = exports.NEUTRAL_400 = exports.NEUTRAL_300 = exports.NEUTRAL_200 = exports.NEUTRAL_1600 = exports.NEUTRAL_1500 = exports.NEUTRAL_1400 = exports.NEUTRAL_1300 = exports.NEUTRAL_1200 = exports.NEUTRAL_1100 = exports.NEUTRAL_1000 = exports.NEUTRAL_100 = exports.MARIGOLD_MEDIUM = exports.MARIGOLD_LIGHT = exports.MARIGOLD_DARK = exports.MARIGOLD = exports.KOALA = exports.HEFFALUMP = exports.GYPSUM = exports.GREAT_WHITE = exports.FLINT = exports.EERIE = exports.CIRRUS = exports.CHART_RED = exports.CHART_ORANGE = exports.CHART_GREEN = exports.CANDY_APPLE = exports.CALYPSO_MEDIUM = exports.CALYPSO_LIGHT = exports.CALYPSO_DARK = exports.CALYPSO = exports.BUTTON_DISABLED_TEXT = exports.BATTLESHIP = void 0;
// Neutral
/**
 * @deprecated Use WHITE instead
 */
const OLAF = exports.OLAF = '#ffffff';
/**
 * @deprecated Use NEUTRAL_100 instead
 */
const GYPSUM = exports.GYPSUM = '#f5f8fa';
/**
 * @deprecated Use NEUTRAL_200 instead
 */
const KOALA = exports.KOALA = '#eaf0f6';
/**
 * @deprecated Use NEUTRAL_300 instead
 */
const GREAT_WHITE = exports.GREAT_WHITE = '#dfe3eb';
/**
 * @deprecated Use NEUTRAL_400 instead
 */
const BATTLESHIP = exports.BATTLESHIP = '#cbd6e2';
/**
 * @deprecated Use NEUTRAL_500 instead
 */
const FLINT = exports.FLINT = '#99acc2';
/**
 * @deprecated Use NEUTRAL_600 instead
 */
const EERIE = exports.EERIE = '#7c98b6';
/**
 * @deprecated Use NEUTRAL_700 instead
 */
const SLINKY = exports.SLINKY = '#516f90';
/**
 * @deprecated Use NEUTRAL_800 instead
 */
const HEFFALUMP = exports.HEFFALUMP = '#425b76';
/**
 * @deprecated Use NEUTRAL_900 instead
 */
const PANTERA = exports.PANTERA = '#2d3e50';

// Calypso
const CALYPSO = exports.CALYPSO = '#00a4bd';
const CALYPSO_DARK = exports.CALYPSO_DARK = '#0091ae';
const CALYPSO_MEDIUM = exports.CALYPSO_MEDIUM = '#7fd1de';
const CALYPSO_LIGHT = exports.CALYPSO_LIGHT = '#e5f5f8';

// Obsidian
const OBSIDIAN = exports.OBSIDIAN = '#33475b';

// Cirrus
const CIRRUS = exports.CIRRUS = '#f2f5f8';

// Norman
const NORMAN = exports.NORMAN = '#f2547d';
const NORMAN_DARK = exports.NORMAN_DARK = '#d94c71';
const NORMAN_MEDIUM = exports.NORMAN_MEDIUM = '#f9aabe';
const NORMAN_LIGHT = exports.NORMAN_LIGHT = '#fdedf2';

// Candy Apple
const CANDY_APPLE = exports.CANDY_APPLE = '#f2545b';

// Oz
const OZ = exports.OZ = '#00bda5';
const OZ_DARK = exports.OZ_DARK = '#00a38d';
const OZ_MEDIUM = exports.OZ_MEDIUM = '#7fded2';
const OZ_LIGHT = exports.OZ_LIGHT = '#e5f8f6';

// Misc.
const BUTTON_DISABLED_TEXT = exports.BUTTON_DISABLED_TEXT = BATTLESHIP;

// Chart Colors
const CHART_GREEN = exports.CHART_GREEN = '#a2d28f';
const CHART_ORANGE = exports.CHART_ORANGE = '#fea58e';
const CHART_RED = exports.CHART_RED = '#ea90b1';

// Trellis Smiley Colors
const TRELLIS_HAPPY = exports.TRELLIS_HAPPY = '#6ACB8C';
const TRELLIS_NEUTRAL = exports.TRELLIS_NEUTRAL = '#EEB117';
const TRELLIS_SAD = exports.TRELLIS_SAD = '#FF7B70';

// Marigold
const MARIGOLD = exports.MARIGOLD = '#f5c26b';
const MARIGOLD_DARK = exports.MARIGOLD_DARK = '#dbae60';
const MARIGOLD_MEDIUM = exports.MARIGOLD_MEDIUM = '#fae0b5';
const MARIGOLD_LIGHT = exports.MARIGOLD_LIGHT = '#fef8f0';

// Thunderdome
const THUNDERDOME = exports.THUNDERDOME = '#6a78d1';
const THUNDERDOME_DARK = exports.THUNDERDOME_DARK = '#5e6ab8';
const THUNDERDOME_MEDIUM = exports.THUNDERDOME_MEDIUM = '#b4bbe8';
const THUNDERDOME_LIGHT = exports.THUNDERDOME_LIGHT = '#f0f1fa';
const WHITE = exports.WHITE = '#ffffff';
const NEUTRAL_100 = exports.NEUTRAL_100 = '#f8f7f6';
const NEUTRAL_200 = exports.NEUTRAL_200 = '#f5f3f2';
const NEUTRAL_300 = exports.NEUTRAL_300 = '#efedeb';
const NEUTRAL_400 = exports.NEUTRAL_400 = '#e7e5e4';
const NEUTRAL_500 = exports.NEUTRAL_500 = '#cfcccb';
const NEUTRAL_600 = exports.NEUTRAL_600 = '#b6b1af';
const NEUTRAL_700 = exports.NEUTRAL_700 = '#9b9897';
const NEUTRAL_800 = exports.NEUTRAL_800 = '#676565';
const NEUTRAL_900 = exports.NEUTRAL_900 = '#4d4c4c';
const NEUTRAL_1000 = exports.NEUTRAL_1000 = '#333333';
const NEUTRAL_1100 = exports.NEUTRAL_1100 = '#292929';
const NEUTRAL_1200 = exports.NEUTRAL_1200 = '#242424';
const NEUTRAL_1300 = exports.NEUTRAL_1300 = '#1f1f1f';
const NEUTRAL_1400 = exports.NEUTRAL_1400 = '#1c1c1c';
const NEUTRAL_1500 = exports.NEUTRAL_1500 = '#171717';
const NEUTRAL_1600 = exports.NEUTRAL_1600 = '#141414';